export default __webpack_public_path__ + "static/media/red-pay.d8faf0c0.png";